import React, { useState, useEffect } from "react";
import axios from "axios";
import { useFieldArray, Controller } from "react-hook-form";
import "../constants/constants.css";
import InputFieldFormArray from "../inputFieldFormArray/InputFieldFormArray";
import "./Images.css";
import { apiUrl } from "../../../constants";

export default function Fields({ control, register, index }) {
  const [result, setResult] = useState([]);
  const [options, setOptions] = useState([]);
  const { fields, append, remove } = useFieldArray({
    control,
    name: `creatives[${index}].images`,
  });

  useEffect(() => {
    async function getAll() {
      const jwtToken = localStorage.getItem("token");
      try {
        const { data } = await axios.get(`${apiUrl}/api/formsettings/publishers`, {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        });
        setResult(data);
      } catch (e) {
        console.error(e);
        if (e.response !== undefined) {
          console.error(e.response.data.message);
        }
      }
    }
    getAll();
  }, []);

  useEffect(() => {
    const options = [];
    result.forEach((currentPublisher) => {
      const newOption = {
        label: currentPublisher.publisher,
        value: currentPublisher._id,
      };
      options.push(newOption);
    });

    setOptions(
      options.sort((a, b) =>
        a.label === b.label ? 0 : a.label < b.label ? -1 : 1
      )
    );
  }, [result]);

  return (
    <div className="form-wrapper">
      <p className="template-examples template-examples-title">
        TEMPLATE EXAMPLES
      </p>
      <ul>
        {fields.map((item, indexImage) => {
          return (
            <li key={item.id}>
              <div className="template-examples-container-form">
                <div className="input-container">
                  <div className="inner-input-container">
                    <div className="wrapper">
                      <section className="select-wrapper">
                        <div className="label-wrapper">
                          <label>Website </label>
                        </div>
                        {options && (
                          <Controller
                            name={`creatives[${index}].images[${indexImage}].website`}
                            control={control}
                            rules={{ required: false }}
                            render={({ field: { onChange, value } }) => {
                              return (
                                <div className="dropdown-label">
                                  <select
                                    value={value}
                                    onChange={onChange}
                                    {...register(
                                      `creatives[${index}].images[${indexImage}].website`,
                                      {
                                        required: false,
                                      }
                                    )}
                                  >
                                    <option
                                      value="none"
                                      defaultValue="Please select"
                                    >
                                      {"Please select"}
                                    </option>
                                    {options.map((option) => (
                                      <option
                                        key={option.value}
                                        value={option.value}
                                      >
                                        {option.label}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              );
                            }}
                          />
                        )}
                      </section>

                      <InputFieldFormArray
                        label="Url to the image from the box "
                        fieldRef={register(
                          `creatives[${index}].images[${indexImage}].url`,
                          {
                            required: false,
                            pattern: {
                              value: /[a-z]/,
                            },
                          }
                        )}
                        name={`creatives[${index}].images[${indexImage}].url`}
                        key={item.id}
                      />
                      <button
                        className="images-button delete-button"
                        type="button"
                        onClick={() => {
                          remove(indexImage);
                        }}
                      >
                        Delete
                      </button>
                    </div>

                    <p className="message">
                      Please insert an image per creative, if you have any
                    </p>
                  </div>
                </div>
              </div>
            </li>
          );
        })}
      </ul>

      <section>
        <button
          className="append-button"
          type="button"
          onClick={() => {
            append({
              website: "",
              url: "",
            });
          }}
        >
          Add Template Examples
        </button>
      </section>
    </div>
  );
}
